import { Box } from '@mui/material';
import loginBg from "assets/images/loginBg.png";
import { refreshTokenRef, tokenRef } from 'common/constant';
import { SCREENS_ROUTES_ENUMS } from 'common/enum';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import FormikValidationError from 'components/ui/FormikErrors';
import TextInput from 'components/ui/TextInput';
import FallBackLoader from 'components/ui/FallBackLoader';
import { useFormik } from 'formik';
import { useLocalStorage } from 'hooks/useStorage';
import { useContext, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { backendURL } from 'redux/reducers/settings';
import { useAdminLogin } from 'service/auth.query';
import * as Yup from 'yup';
import ForgotPasswordModal from './ForgetPassModal';

const LoginSchema = Yup.object().shape({
  password: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Password is required'),
  email: Yup.string().email('Invalid email').required('Email is required')
});

const UserLogin = () => {
  // Read token only for the "already logged in" guard — do NOT use setToken
  // after login (same reason as Admin Login: avoids the premature Navigate flash).
  const { value: token } = useLocalStorage(tokenRef);
  const [openForgetPasswordModal, setOpenForgetPasswordModal] = useState(false);
  const [passwordToogle, setPasswordToogle] = useState('password');
  // Full-screen loader shown after a successful login while the page reloads
  const [redirecting, setRedirecting] = useState(false);
  const { appConfig } = useContext(ConfigurationContext);

  const togglePassword = () => {
    if (passwordToogle === 'password') {
      setPasswordToogle('text');
      return;
    }
    setPasswordToogle('password');
  };

  const { mutate: userLogin, isLoading } = useAdminLogin();

  const formik = useFormik({
    validationSchema: LoginSchema,
    initialValues: {
      email: '',
      password: ''
    },
    onSubmit: (values) => {
      const payload = {
        email: values.email,
        password: values.password,
        user_type: 2
      };
      userLogin(payload, {
        onSuccess: (res) => {
          if (res?.data.code == 200) {
            toast.success(res?.data?.message);
            // Write directly and synchronously so the token is in localStorage
            // before location.reload() fires — no race condition.
            window.localStorage.setItem(tokenRef, JSON.stringify(res?.data.data?.access));
            window.localStorage.setItem(
              refreshTokenRef,
              JSON.stringify(res?.data.data?.refresh)
            );
            // Show loader, then reload so App.tsx picks up the correct role.
            setRedirecting(true);
            setTimeout(() => location.reload(), 800);
          }
        },
        onError: (err: any) => {
          toast.error(err.error?.data?.message);
        }
      });
    }
  });

  // Already authenticated
  if (token) {
    return <Navigate to="/" replace={true} />;
  }

  // Show full-screen loader while the page is about to reload after login.
  if (redirecting) {
    return <FallBackLoader />;
  }
  const handleOpenModal = () => {
    setOpenForgetPasswordModal(true);
  };

  const handleCloseModal = () => {
    setOpenForgetPasswordModal(false);
  };
  return (
    <>
      <ForgotPasswordModal
        handleClose={handleCloseModal}
        openForgetPasswordModal={openForgetPasswordModal}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundImage: `url(${loginBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: '#ffff',
          width: "100%",

        }}

      >

        {/* <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100"> */}
        {/* <div className="bg-overlay" /> */}
        <div className=" overflow-hidden pt-lg-5 col-12">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="card overflow-hidden">
                  <div className="row g-0">
                    <div className="col-lg-6">
                      <div className="p-lg-5 p-4 auth-one-bg h-100 position-relative overflow-hidden">
                        {appConfig?.login_image && (
                          <img
                            src={backendURL + appConfig.login_image}
                            alt="auth-bg"
                            style={{
                              position: 'absolute',
                              justifyContent: 'center',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              // objectFit: 'cover',
                              zIndex: 0
                            }}
                          />
                        )}
                        <div className="bg-overlay" />
                        <div className="position-relative h-100 d-flex flex-column">
                          <div className="mt-auto">
                            <div className="mb-3">
                              <i className="ri-double-quotes-l display-4 text-success" />
                            </div>
                            <div
                              id="qoutescarouselIndicators"
                              className="carousel slide"
                              data-bs-ride="carousel">
                              <div className="carousel-indicators">
                                <button
                                  type="button"
                                  data-bs-target="#qoutescarouselIndicators"
                                  data-bs-slide-to={0}
                                  className="active"
                                  aria-current="true"
                                  aria-label="Slide 1"
                                />
                                <button
                                  type="button"
                                  data-bs-target="#qoutescarouselIndicators"
                                  data-bs-slide-to={1}
                                  aria-label="Slide 2"
                                />
                                <button
                                  type="button"
                                  data-bs-target="#qoutescarouselIndicators"
                                  data-bs-slide-to={2}
                                  aria-label="Slide 3"
                                />
                              </div>
                              <div className="carousel-inner text-center text-white-50 pb-5">
                                <div className="carousel-item active">
                                  <p className="fs-15 fst-italic">
                                    " Create Assignment, Courses and Training "
                                  </p>
                                </div>
                                <div className="carousel-item">
                                  <p className="fs-15 fst-italic">
                                    " Assign Coordinator and Evaluator to the routine"
                                  </p>
                                </div>
                                <div className="carousel-item">
                                  <p className="fs-15 fst-italic">
                                    " Add trainee, coordinator and evaluator in the system "
                                  </p>
                                </div>
                              </div>
                            </div>
                            {/* end carousel */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* end col */}
                    <div className="col-lg-6">
                      <div className="p-lg-5 p-4">
                        <div className='d-flex justify-content-center align-items-center flex-column'>


                          {appConfig?.login_image && (
                            <img
                              src={backendURL + appConfig.logo}
                              alt="auth-bg"
                              style={{
                                justifyContent: 'center',
                                width: '20%',
                                height: '20%',
                              }}
                            />
                          )}
                          <h5 className="text-primary">{appConfig?.title || 'Welcome Back!'}</h5>


                        </div>
                        {/* <div>
                          <h5 className="text-primary">Welcome Back ! Trainee login</h5>
                        </div> */}
                        <div className="mt-4">
                          <form className="" onSubmit={formik.handleSubmit}>
                            <TextInput
                              label="Email"
                              placeholder="Enter email"
                              containerClassName="mb-3"
                              name="email"
                              type="email"
                              onChange={formik.handleChange}
                              value={formik.values.email}
                              onBlur={formik.handleBlur}
                              formik={formik}
                            />

                            <div>
                              <label className="form-label">Password</label>
                              <div className="position-relative auth-pass-inputgroup">
                                <input
                                  name="password"
                                  type={passwordToogle}
                                  className="form-control pe-5"
                                  placeholder="Enter password"
                                  id="password-input"
                                  onChange={formik.handleChange}
                                  value={formik.values.password}
                                  onBlur={formik.handleBlur}
                                />
                                <button
                                  aria-label="view password"
                                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                  type="button"
                                  id="password-addon">
                                  <i
                                    className="ri-eye-fill align-middle"
                                    onClick={togglePassword}></i>
                                </button>
                              </div>
                            </div>

                            <FormikValidationError
                              name="password"
                              errors={formik.errors}
                              touched={formik.touched}
                            />



                            <div className="form-check d-flex align-items-center justify-content-end">
                              <div className="float-end">
                                <p onClick={() => handleOpenModal()} className=" btn btn-link ">
                                  Forgot password?
                                </p>
                              </div>
                            </div>
                            <div className="flex gap-2  mt-2">

                              <button
                                title="Login"
                                type="submit"
                                disabled={isLoading}
                                className='btn btn- add-btn outline-primary col-12 bg-primary text-white'
                              >
                                {isLoading ? 'Logging in...' : 'Login'}
                              </button>
                            </div>

                            <div className='my-4 flex justify-content-center'>
                              Don't have an account ?<a href={SCREENS_ROUTES_ENUMS.REGISTER} className="btn btn-link "> Register</a>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="mb-0">© All Right Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </footer> */}

        {/* </div> */}
      </Box>

    </>
  );
};

export default UserLogin;
